import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Inbox = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C2.89543 2 2 2.89543 2 4V10V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V10V4C14 2.89543 13.1046 2 12 2H4ZM13 9.5V4C13 3.44772 12.5523 3 12 3H4C3.44772 3 3 3.44772 3 4V9.5H5.73241C6.06676 9.5 6.37899 9.6671 6.56446 9.9453L7.26759 11H8.69098L9.16459 10.0528C9.33398 9.714 9.68024 9.5 10.059 9.5H13ZM3 10.5H5.73241L6.43554 11.5547C6.62101 11.8329 6.93324 12 7.26759 12H8.69098C9.06976 12 9.41602 11.786 9.58541 11.4472L10.059 10.5H13V12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12V10.5ZM5.5 5.5C5.5 5.22386 5.72386 5 6 5H10C10.2761 5 10.5 5.22386 10.5 5.5C10.5 5.77614 10.2761 6 10 6H6C5.72386 6 5.5 5.77614 5.5 5.5ZM6 7C5.72386 7 5.5 7.22386 5.5 7.5C5.5 7.77614 5.72386 8 6 8H10C10.2761 8 10.5 7.77614 10.5 7.5C10.5 7.22386 10.2761 7 10 7H6Z"
      />
    </svg>
  )
})

export default Inbox
